import { useId, useState } from 'react';
import ActionLink from '../../../../Components/Dashboard/ActionLink';
import Card from '../../../../Components/Dashboard/Card';
import { CardEmpty } from '../../../../Components/Dashboard/CardState';
import { calculateAerobicTrainingZones } from '../../TestsPage/zones';
import { cssToPacePer100 } from '../../../../Utils/format/pace';
import styles from '../dashboardCards.module.css';

// Same aerobic options as the Training Zones page (kept local: that page does not export them).
const AEROBIC_DISTANCES = [100, 200, 300, 400];

// The card does no pace maths of its own: every string comes from zones.js for the athlete's CSS.
const ZonePacesCard = ({ css, testsPath = '/tests' }) => {
    const hasCss = typeof css === 'number' && css > 0;
    const [distance, setDistance] = useState(100);
    const selectId = useId();
    const zones = hasCss ? calculateAerobicTrainingZones(css, distance) : null;

    return (
        <Card
            id="zp"
            module="athlete-paces"
            title="Zone paces"
            sub={hasCss ? `from current CSS ${cssToPacePer100(css)}` : undefined}
            flush={hasCss}
        >
            {!hasCss ? (
                <CardEmpty>
                    <span>Set your CSS by logging a test</span>{' '}
                    <ActionLink to={testsPath}>Log test</ActionLink>
                </CardEmpty>
            ) : (
                <>
                <div className={styles.zoneDistance}>
                    <label htmlFor={selectId}>Distance</label>
                    <select id={selectId} value={distance} onChange={e => setDistance(Number(e.target.value))}>
                        {AEROBIC_DISTANCES.map(d => (
                            <option key={d} value={d}>
                                {d} m
                            </option>
                        ))}
                    </select>
                    <span>{`Pace per 100 m for ${distance} m repeats`}</span>
                </div>
                <table className={styles.data}>
                    <thead>
                        <tr>
                            <th>Zone</th>
                            <th>Purpose</th>
                            <th className={styles.num}>Pace /100 m</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Rec</td>
                            <td>Over distance</td>
                            <td className={styles.num}>{zones.zone1.timeTo} +</td>
                        </tr>
                        {[
                            ['End1', zones.zone2, 'Basic aerobic'],
                            ['End2', zones.zone3, 'Lactate threshold'],
                            ['End3', zones.zone4, 'VO2 max']
                        ].map(([name, z, purpose]) => (
                            <tr key={name}>
                                <td>{name}</td>
                                <td>{purpose}</td>
                                <td className={styles.num}>{`${z.timeFrom} – ${z.timeTo}`}</td>
                            </tr>
                        ))}
                        <tr>
                            <td>SP1–SP3</td>
                            <td>Lactate tolerance → max speed</td>
                            <td className={styles.num}>by effort</td>
                        </tr>
                    </tbody>
                </table>
                </>
            )}
        </Card>
    );
};

export default ZonePacesCard;
